export default __webpack_public_path__ + "static/media/cannibalism.1619e408.png";